module.exports = __webpack_public_path__ + "assets/img/17_1607_big.c93644e1.jpg";